import React from "react";
import { Paper, Box, Typography, Tooltip } from "@mui/material";
import { ORIGEN_CONFIG } from "../constants";

// Barra apilada con el peso de cada origen sobre el total
export const BarraDistribucion = ({ origenes, porOrigen, total }) => {
  if (!total) return null;

  return (
    <Paper elevation={0} sx={{ p: 2, mb: 2, border: "1px solid #e0e0e0", borderRadius: 2 }}>
      <Typography variant="body2" sx={{ color: "#5f6368", fontWeight: 500, mb: 1.5 }}>
        Distribución por origen
      </Typography>

      <Box sx={{ display: "flex", height: 12, borderRadius: 6, overflow: "hidden", bgcolor: "#f1f3f4" }}>
        {origenes.map((origen) => {
          const cantidad = porOrigen[origen] || 0;
          if (!cantidad) return null;
          const porcentaje = (cantidad / total) * 100;
          return (
            <Tooltip key={origen} title={`${origen}: ${cantidad} (${Math.round(porcentaje)}%)`} arrow>
              <Box sx={{ width: `${porcentaje}%`, bgcolor: ORIGEN_CONFIG[origen].hex, transition: "width 0.3s ease" }} />
            </Tooltip>
          );
        })}
      </Box>

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2.5, mt: 1.5 }}>
        {origenes.map((origen) => (
          <Box key={origen} sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
            <Box sx={{ width: 10, height: 10, borderRadius: "50%", bgcolor: ORIGEN_CONFIG[origen].hex }} />
            <Typography variant="caption" sx={{ color: "#5f6368" }}>
              {origen} · {porOrigen[origen] || 0}
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};
